import { FC } from "react";
import Login from "../components/login/Login";

const LoginPage: FC = () => {
  return <Login />;
};

export default LoginPage;